/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Course_Locked_FallbackInputs */

const en_player_course_locked_fallback = /** @type {(inputs: Player_Course_Locked_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This course is locked.`)
};

const ja_player_course_locked_fallback = /** @type {(inputs: Player_Course_Locked_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このコースはロックされています。`)
};

const fr_player_course_locked_fallback = /** @type {(inputs: Player_Course_Locked_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce cours est verrouillé.`)
};

const de_player_course_locked_fallback = /** @type {(inputs: Player_Course_Locked_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Kurs ist gesperrt.`)
};

/**
* | output |
* | --- |
* | "This course is locked." |
*
* @param {Player_Course_Locked_FallbackInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_course_locked_fallback = /** @type {((inputs?: Player_Course_Locked_FallbackInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Course_Locked_FallbackInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_course_locked_fallback(inputs)
	if (locale === "ja") return ja_player_course_locked_fallback(inputs)
	if (locale === "fr") return fr_player_course_locked_fallback(inputs)
	return de_player_course_locked_fallback(inputs)
});